import styled from 'styled-components'

export const Container = styled.div`
	form {
		@media(max-width: 700px) {
			display: flex;
			flex-direction: column;
			align-items: stretch;

			> button {
				margin-top: 14px;
			}
		}

		.label {
			margin: 0;
		}
	}
`
